export class EventBusComponent extends HTMLElement {
  static instance = null;

  // Singleton che ritorna l'unica istanza dell'eventBus istanziabile in fase di rendering di una pagina del sito
  static getInstance() {
    if (!EventBusComponent.instance) {
      EventBusComponent.instance = new EventBusComponent();
    }
    return EventBusComponent.instance;
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open'});
    this.subscribers = {};
  }

  // Funzione che permette a un componente di "iscriversi" a un determinato evento triggerabile sull'eventBus
  subscribe(eventName, callback) {
    if (!this.subscribers[eventName]) {
      this.subscribers[eventName] = [];
    }
    this.subscribers[eventName].push(callback);
  }

  // Funzione che permette a un componente di "disiscriversi" da un determinato evento triggerabile sull'eventBus
  unsubscribe(eventName, callback) {
    if (!this.subscribers[eventName]) {
      return;
    }
    this.subscribers[eventName] = this.subscribers[eventName].filter(
      cb => cb !== callback
    );
  }

  // Funzione che permette a un componente iscritto all'eventBus di generare un evento che possa essere intercettato
  // anche dagli altri WebComponents iscritti allo stesso eventBus e generare side-effects su di essi nel momento
  // in cui quello specifico evento viene generato
  publish(eventName, data) {
    if (!this.subscribers[eventName]) {
      return;
    }
    this.subscribers[eventName].forEach(callback => callback(data));
  }
}

window.customElements.define("event-bus-component", EventBusComponent);